// esTranslationRateInfo.ts

export const EV2_A = `### Plan de Tarifas: EV2-A

Sin niveles; horario de uso, para clientes residenciales con un vehículo eléctrico. [Más información.](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/electric-vehicle-base-plan/electric-vehicle-base-plan.page)

Los costos en el Plan de Tarifas EV2-A de Carga en el Hogar son más bajos de 12 a.m. a 3 p.m., todos los días, incluyendo fines de semana y feriados cuando la demanda es menor, lo que hace que este sea el mejor momento para cargar su vehículo. La electricidad es más cara durante los períodos de Horas Pico (4 - 9 p.m.) y Horas Pico Parciales (3 - 4 p.m. y 9 p.m. - 12 a.m.).

El Plan de Tarifas EV2-A de Carga en el Hogar incluye un Cargo por Servicios Básicos y precios de kWh reducidos a partir de marzo de 2026. Visite [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) para más información.

#### Clientes que pueden beneficiarse

Este plan de tarifas funciona para clientes que tienen un vehículo eléctrico (EV) y/o almacenamiento por batería y pueden cargar durante las horas fuera de pico de 12 a.m. a 3 p.m., además de trasladar otro consumo de energía del hogar a las horas fuera de pico.

#### Descripción

Este plan de tarifas se aplica tanto al uso de energía del hogar como a la carga de vehículos eléctricos y/o baterías.

Ofrece precios más bajos durante los momentos del día en que los costos de suministro de energía son menos costosos.

#### Cosas a considerar

Evite cargar durante las horas pico. Para maximizar los ahorros, considere trasladar otro consumo de energía del hogar a horas de menor demanda y menos costosas (consulte el gráfico anterior).

Los clientes con un alto consumo de energía (más del 800% de la asignación básica) en los últimos 12 meses no son elegibles para esta tarifa.

[Más información sobre el Plan de Tarifas EV2-A de Carga en el Hogar](https://www.pge.com/en/account/rate-plans/electric-vehicles.html#ev2adetails)`;

export const E_ELEC = `### Plan de Tarifas: E-ELEC

Plan de tarifas de PG&E para un hogar eléctrico. [Más información.](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/electric-home-rate-plan.page)

El Plan de Tarifas para el Hogar Eléctrico (E-ELEC) es ideal para clientes que han comenzado a electrificar su hogar con uno o más de los siguientes: Vehículos Eléctricos (EV), almacenamiento por batería, acondicionamiento de espacios con bomba de calor o calentadores de agua con bomba de calor.

El Plan de Tarifas para el Hogar Eléctrico (E-ELEC) incluye un Cargo por Servicios Básicos y precios de kWh reducidos a partir de marzo de 2026. Visite [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) para más información.

#### Cómo funciona

El precio que paga cambia según la hora del día:
- Pico (precio más alto) - 4 p.m. a 9 p.m.
- Pico Parcial - entre 3 p.m. y 4 p.m., y entre 9 p.m. y 12 a.m.
- Fuera de Pico (precio más bajo) - entre 12 a.m. y 3 p.m.

A diferencia de otras tarifas, no hay niveles y las tarifas son para los 7 días de la semana.

#### Qué significa para usted
 
- Si usted es un gran consumidor de electricidad que puede trasladar el uso a horarios de menor precio, este plan de tarifas puede ahorrarle dinero.
- Su hogar no necesita ser totalmente eléctrico para calificar para este plan de tarifas.

[Más información sobre el Plan de Tarifas para el Hogar Eléctrico (E-ELEC)](https://www.pge.com/en/account/billing-and-assistance/base-services-charge.html)`;

export const EV_B = `### Plan de Tarifas: EV-B

Sin niveles; horario de uso, para clientes residenciales con un vehículo eléctrico. Este plan de tarifas implica la instalación de otro medidor, que separa los costos de electricidad de su vehículo de los de su hogar. [Más información.](https://www.pge.com/tariffs/assets/pdf/tariffbook/ELEC_SCHEDS_EV%20(Sch).pdf)

Los costos en EV-B son más bajos de 11 p.m. a 7 a.m. cuando la demanda es menor, lo que hace que este sea el mejor momento para cargar su vehículo. La electricidad es más cara durante los períodos de Horas Pico (2 - 9 p.m.) y Horas Pico Parciales (7 a.m. - 2 p.m. y 9 - 11 p.m.).

#### Clientes que pueden beneficiarse

Clientes que desean rastrear la carga de su EV por separado del consumo de energía de su hogar con un medidor dedicado. Si puede reducir su uso de 7 a.m. a 11 p.m. de lunes a viernes, y de 3 p.m. a 7 p.m. los fines de semana y feriados, este plan de tarifas puede ser el mejor para usted.

#### Descripción

Medidores duales: uno para su hogar y otro para la carga del vehículo eléctrico. El precio de la carga varía a lo largo del día. El uso de energía de su hogar se mide por separado.

#### Cosas a considerar

Evite cargar durante las horas pico. Los costos de instalación del segundo medidor pueden ser significativos. Una tarifa única de $100 por medidor, más el costo de instalación de la estación de carga y el segundo panel eléctrico. También puede ser necesaria una actualización del servicio. Los costos generalmente rondan los $2,000 y pueden llegar hasta los $8,000 dependiendo de las características del sitio.

Cargos

| Tarifas de Energía Totales ($ por kWh) | Verano | Invierno |
| --- | --- | --- |
| Pico | $0.60057 | $0.41855 |
| Pico Parcial | $0.35646 | $0.28654 |
| Fuera de Pico | $0.24391 | $0.21481 |

Cargo Total del Medidor: $0.04928 por día.

Consulte [aquí](https://www.pge.com/tariffs/assets/pdf/tariffbook/ELEC_SCHEDS_EV%20(Sch).pdf) para conocer las definiciones de los períodos de tiempo y los cargos.`;

export const E_1 = `### Plan de Tarifas: E-1

Plan de Tarifas por Niveles de PG&E. [Más información.](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/tiered-base-plan/tiered-base-plan.page)

Este plan de tarifas tiene dos niveles de precios, conocidos como "niveles", que se basan en la cantidad de energía que utiliza.

El Plan de Tarifas por Niveles (E-1) incluye un Cargo por Servicios Básicos y precios de kWh reducidos a partir de marzo de 2026. Visite [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) para más información.

#### Entendiendo la Asignación Básica (Baseline Allowance)

El primer nivel y el de menor precio se llama su Asignación Básica. Consiste en una asignación de energía basada en el lugar donde vive, su fuente de calefacción y la temporada (verano o invierno). El verano abarca desde el 1 de mayo hasta el 31 de octubre y el invierno desde el 1 de noviembre hasta el 30 de abril.

- La energía utilizada dentro de su Asignación Básica se factura al precio más bajo.
- La energía utilizada por encima de la Asignación Básica se considera Nivel 2 y se factura a un precio más alto.

[Encuentre su Asignación Básica.](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/tiered-base-plan/understanding-baseline-allowance.page)

[Más información sobre el Plan de Tarifas por Niveles (E-1)](https://www.pge.com/en/account/rate-plans/tiered-rate-plan.html)`;

export const E_TOU_C = `### Plan de Tarifas: E-TOU-C

Plan de Tarifas de Horario de Uso con Precios Pico de 4 a 9 p.m. Todos los Días (E-TOU-C). [Más información](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/tou-everyday.page)

Este plan de tarifas ofrece precios más bajos (fuera de pico) antes de las 4 p.m. y después de las 9 p.m. todos los días.

El plan E-TOU-C de Precios Pico de 4 a 9 p.m. Todos los Días incluye un Cargo por Servicios Básicos y precios de kWh reducidos a partir de marzo de 2026. Visite [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) para más información.

#### Cómo funciona:

El precio que paga cambia según la hora del día

-   Pico (precio más alto) -- 4 p.m. a 9 p.m. todos los días
-   Fuera de Pico (precio más bajo) -- antes de las 4 p.m. y después de las 9 p.m. todos los días

#### Qué significa para usted:

-   Puede ahorrar dinero si logra reducir su consumo de energía en general y especialmente durante las horas de mayor precio (pico).

[Más información sobre el Plan de Tarifas de Horario de Uso con Precios Pico de 4 a 9 p.m. Todos los Días (E-TOU-C).](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/tou-everyday.page)`;

export const E_TOU_D = `### Plan de Tarifas: E-TOU-D

Plan de Tarifas de Horario de Uso con Precios Pico de 5 a 8 p.m. Días Laborables (E-TOU-D). [Más información.](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/time-of-use-plan.page)

Este plan de tarifas ofrece precios más bajos durante los períodos del día en que los costos de energía son menores: antes de las 5 p.m. y después de las 8 p.m. en días laborables y durante todas las horas los fines de semana y la mayoría de los feriados.

El Plan de Tarifas de Horario de Uso con Precios Pico de 5 a 8 p.m. Días Laborables (E-TOU-D) incluye un Cargo por Servicios Básicos y precios de kWh reducidos a partir de marzo de 2026. Visite [pge.com/baseservicescharge](https://www.pge.com/baseservicescharge) para más información.

#### Cómo funciona:

El precio que paga cambia según la hora del día, el día de la semana y la temporada

-   Pico (precio más alto) -- 5 p.m. a 8 p.m. de lunes a viernes (excepto la mayoría de los feriados)
-   Fuera de Pico (precio más bajo) -- antes de las 5 p.m. y después de las 8 p.m. de lunes a viernes y todas las horas los fines de semana y la mayoría de los feriados

-   Ocho meses (octubre a mayo) tienen precios más bajos que los cuatro meses de verano (junio a septiembre).
-   A diferencia del Plan de Tarifas E-TOU-C, no hay Asignación Básica (Baseline Allowance) en este plan de tarifas.

#### Qué significa para usted:

-   Tiene la oportunidad de ahorrar dinero si puede reducir su consumo de energía en general y especialmente durante las horas de mayor precio (pico).
-   El Plan de Tarifas E-TOU-D puede ser más atractivo para los consumidores de alta energía porque los precios de la electricidad son más bajos que en el Plan E-TOU-C una vez que su consumo mensual de electricidad supera el monto del Nivel 1 (Asignación Básica).

[Más información sobre el Plan de Tarifas de Horario de Uso con Precios Pico de 5 a 8 p.m. Días Laborables (E-TOU-D)](https://www.pge.com/en_US/residential/rate-plans/rate-plan-options/time-of-use-base-plan/tou-weekdays.page)`;
